import React from 'react';
import { reduxWrapper } from '@common/redux/store';
import { NotFoundPage } from '@kursk/components/pages/404/NotFoundPage';
import { IframeSingleEvent } from '@kursk/components/pages/IframeSingleEvent/IframeSingleEvent';
import axios from 'axios';
import { api } from '@common/urls';
import { IEvent } from '@common/redux/types/event';
import { getConfig } from '@root/config/config';

type TProps = {
  event: IEvent | null;
}
export default function Event({ event }: TProps) {

  if (!event) {
    return (<NotFoundPage/>);
  }
  return (
    <IframeSingleEvent event={event}/>
  );
}

export const getServerSideProps = reduxWrapper.getServerSideProps(async ({ params }) => {
  const { sysName } = params;
  const { data } = await axios.get(
    api.events.getOneBySysName(sysName as string),
    {
      params: {
        schedulesActiveDays: getConfig().eventSchedulesActiveDays,
      }
    }
  );
  if (!data?.event?._id) {
    return {
      props: { event: null }
    };
  } else {
    return {
      props: { event: data.event }
    }
  }
});
